import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import MyWalletSidebar from "../MyWalletSidebar";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import "./ExamCourseWalletLayout.css";
import HeaderProfileSection from "../HeaderProfileSection";
import CourseTab from "./CourseTab";
import { useExamOverview } from "../../hooks/useExamOverview";
import { getSearchRouteState } from "../search/searchFlow";
const CourseDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const flow = getSearchRouteState(location.pathname, location.state);
  const examsId = Number(flow.exams_id || flow.selectedExam?.id || 0);
  const {
    data: overview = {},
    isLoading,
    isError,
    error,
  } = useExamOverview(examsId);
  const examName =
    overview?.exam_name || flow.selectedExam?.name || "Exam Course";

  return (
    <>
      <style>
        {`
        .homeDashboard-wrapper .main-content {
          height: calc(100vh - 44px) !important;
          overflow: scroll !important;
          height: 00;
          min-height: 0 !important;
          padding-bottom: 0;
          overflow-x: hidden !important;
         }
          .page-padding {
         padding: 30px 25px 0!important;
              }
         .exam-course-wallet-layout .instruction-main {
             padding-bottom: 0;
          }
        .categories-page-header {
          padding: 25px 15px 0;
         }
        @media (max-width: 991px) {
         .game-description {
           margin: 8px 0 0px;
        }
        }
      @media (max-width: 767.98px) {
        .qbl-page {
          padding: 18px 0px 22px !important;
        }
       .categories-page-header {
          padding: 0px 15px 0;
       }
      .coursePriceSection {
        padding: 0 10px;
     }
     .qb-title {
        line-height: 1.1;
      }
      }
        `}
      </style>
      <HomeDashboardLayout
        showHeader={false}
        variant="exam-course-wallet-layout"
      >
        <div className="qbl-page qbankList-page ">
          <div className="start-quiz qbl-main  instruction-main">
            <div className="hideProfile-page ">
              {/* Page header */}
              <div className="categories-page-header mb-0">
                <div>
                  <button
                    type="button"
                    className="categories-back-button"
                    onClick={() => navigate(-1)}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </div>
                <div />
                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>

            {/* Courses Title Heading*/}

            <div className="rapid-fire-card examCardd pb-0">
              {/* Header */}
              <div className="rapid-fire-header ex-header">
                <h1 className="qb-title">{examName}</h1>
              </div>

              {/* Description */}
              <p className="game-description ">
                {overview?.category_name || "Course overview"}
              </p>
            </div>

            {/* Courses  Tab*/}

            <CourseTab
              overview={overview}
              isOverviewLoading={isLoading}
              overviewError={
                isError ? error?.response?.data?.message || error?.message : ""
              }
              examsId={examsId}
            />
          </div>
        </div>
        <MyWalletSidebar withTopOffset={false} />
      </HomeDashboardLayout>
    </>
  );
};

export default CourseDetail;
